import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { REDCRSS_EVENTS } from '../../../../../shared/services/constants/redcross_evemts';
import { AccordionItem, AccordionItemClass } from '../accordion_item';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-accordion-item',
  template: require('./accordion_item.component.html'),
  styles: [require('./accordion_item.component.scss'), require('./accordion_item_context.component.scss')]
})

export class AccordionItemComponent {

  @Input() item: any;
  @Output() setActiveItemState: any = new EventEmitter();
  @Output() openNextItem: any = new EventEmitter();

  @ViewChild('scrollingAnchor') el: ElementRef;

  constructor(private redcrossService: AnalyticsTrackingProvider, protected translate: TranslateService) { }

  setActive(activateItem: AccordionItem) {
    this.scrollIntoView();
    this.setActiveItemState.emit(activateItem);
    this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Tab',
      ctaLocation: this.translate.instant(this.item.title),
      ctaIsOpen: activateItem.active
    });
  }

  openNext(activateItem) {
    this.scrollIntoView();
    this.openNextItem.emit(activateItem);
  }

  scrollIntoView() {
    this.el.nativeElement.scrollIntoView();
  }

  getClass(item: AccordionItem): string {
    if (item.active) {
      return item.id + 'Active';
    } else {
      return 'inactive';
    }
  }

  getInstance(item: AccordionItem): AccordionItemClass {
    return new AccordionItemClass(item.component, item.id, item.title, item.description, item. timeToComplete, item.active,
      item.data, item.nextItem);
  }
}
